module.exports = __webpack_public_path__ + "img/10.7fe8d121.jpg";